export default "__VITE_ASSET__C3NH7j0o__"